import { region } from "~~/types";
import type { PublicAppConfig } from "~~/types/publicConfig";

export class ConfigRepository {
	private config = useRuntimeConfig();

	/**
	 * Get the current active configuration
	 */
	getCurrentConfig(): region {
		return this.config.public.activeConfig;
	}

	/**
	 * Public boot config from the API (contact emails, etc).
	 * Source of truth lives in the backend env / mail config.
	 */
	async fetchPublicConfig(): Promise<PublicAppConfig | null> {
		try {
			const result = await $fetch<{ data: PublicAppConfig }>(`${this.config.public.activeConfig.apiUrl}/config`);
			return result?.data ?? null;
		} catch {
			return null;
		}
	}

	/**
	 * Get SZMD URL with language replacement
	 * @param lang - Language code to replace _lang_ placeholder with
	 * @returns SZMD URL
	 */
	getSzmdUrl(lang = "hu"): string {
		const currentConfig = this.getCurrentConfig();
		const urlList = currentConfig.szmd;

		// If lang key exists, return its value
		if (urlList[lang]) {
			return urlList[lang];
		}

		// Return first element if lang key doesn't exist
		const firstKey = Object.keys(urlList)[0];
		return urlList[firstKey];
	}

	/**
	 * Get Premium Recruitment URL with language replacement
	 * @param lang - Language code to replace _lang_ placeholder with
	 * @returns Premium Recruitment URL
	 */
	getPremiumRecruitmentUrl(lang = "hu"): string {
		const currentConfig = this.getCurrentConfig();
		const urlList = currentConfig.premiumRecruitment;

		// If lang key exists, return its value
		if (urlList[lang]) {
			return urlList[lang];
		}

		// Return first element if lang key doesn't exist
		const firstKey = Object.keys(urlList)[0];
		return urlList[firstKey];
	}

	getSalaryCalculatorUrl(lang = "hu"): string {
		const currentConfig = this.getCurrentConfig();
		const urlList = currentConfig.salaryCalculator;

		if (urlList[lang]) {
			return urlList[lang];
		}

		const firstKey = Object.keys(urlList)[0];
		return urlList[firstKey];
	}
}
